// src/api/axios.js
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:4321';

/**
 * Kept the same signature so existing imports still work.
 * `org` is ignored now (single unified backend).
 */
export function createApiForOrg(_org, getAccessToken, refreshAccessToken) {
  const api = axios.create({ baseURL: API_BASE, withCredentials: false });

  // Attach bearer
  api.interceptors.request.use(cfg => {
    const token = getAccessToken?.();
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
  });

  // Auto refresh once on 401
  let refreshing = null;
  api.interceptors.response.use(
    r => r,
    async err => {
      const original = err?.config;
      if (!original || original.__retried) throw err;
      if (err?.response?.status === 401 && refreshAccessToken) {
        try {
          original.__retried = true;
          const newAccess = await refreshAccessToken();
          if (newAccess) {
            original.headers = { ...(original.headers || {}), Authorization: `Bearer ${newAccess}` };
            return api(original);
          }
        } catch { /* swallow */ }
      }
      throw err;
    }
  );

  return api;
}
